import React from "react"
import styles from "./loader.module.css"
import clsx from "clsx"

const LOADER_SIZES = {
  "xs": "1.125rem",
  "sm": "1.375rem",
  "md": "2.25rem",
  "lg": "2.75rem",
  "xl": "3.625rem",
}

/**
 * @typedef {Object} LoaderProps
 * @property {keyof typeof LOADER_SIZES} [size]
 * @property {string} [title]
 */

/**
 * @param {LoaderProps} props 
 */
export function Loader({ title, size }) {
  return (
    <span
      role="status"
      className={clsx(
        "inline-flex items-center justify-center",
        title && "flex-col space-y-4",
      )}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        className={styles.loader}
        style={{
          "--loader-size": LOADER_SIZES[size]
        }}
      >
        <circle className={styles.loaderCircle} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path className={styles.loaderCirclePath} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
      </svg>
      {title ? <span className={styles.loaderTitle}>{title}</span> : null}
    </span>
  )
}